export default __webpack_public_path__ + "static/logo-9543c8bbacf761fc1bfe722b6b920f20.svg";